<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">流量推广&nbsp;&nbsp;&nbsp;精准营销
          助你轻松实现商业目标</div>
        <div class="popularize">
          <div class="item">
            <img src="@/assets/images/solution/popularize_banner01.png" alt="">
            <span>多广告平台海量优质流量</span>
          </div>
          <div class="item">
            <img src="@/assets/images/solution/popularize_banner02.png" alt="">
            <span>全站短视频营销解决方案</span>
          </div>
          <div class="item">
            <img src="@/assets/images/solution/popularize_banner03.png" alt="">
            <span>服务商家全方位互联网推广</span>
          </div>
        </div>
        <div class="desc">定制化投放方案， 覆盖用户各个使用场景，7×24 小时无缝触达您的目标客户，高效达成你的各种营销目标 </div>
      </div>
    </div>
    <div class="block-po01">
      <div class="sk-block-title">
        <div class="title">您是否还存在以下痛点？</div>
      </div>
      <div class="content-01">
        <div v-for="(item, index) in painSpotList" :key="`painSpotList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/popularize-icon-0${index+1}.png`)" alt="">
          <div class="title">{{ item.title }}</div>
          <div class="sub-title" v-html="item.subTitle" />
        </div>
      </div>
    </div>
    <div class="block-po02" style="padding-bottom: 71px;">
      <div class="sk-block-title">
        <div class="title">锁定营销目标  提升转化  降低成本</div>
      </div>
      <div class="content-02">
        <div class="item item-01">
          <img class="img" src="@/assets/images/solution/popularize-icon1-01.png" alt="">
          <div class="line" />
          <div class="name">品牌曝光</div>
        </div>
        <div class="item item-02">
          <img class="img" src="@/assets/images/solution/popularize-icon1-02.png" alt="">
          <div class="line" />
          <div class="name">产品售卖</div>
        </div>
        <div class="item item-03">
          <img class="img" src="@/assets/images/solution/popularize-icon1-03.png" alt="">
          <div class="line" />
          <div class="name">客资收集</div>
        </div>
        <div class="item item-04">
          <img class="img" src="@/assets/images/solution/popularize-icon1-04.png" alt="">
          <div class="line" />
          <div class="name">门店引流</div>
        </div>
      </div>
    </div>
    <div class="block-po01">
      <div class="content-03">
        <div class="item-lf">
          <div class="name">巨量广告</div>
          <div class="line" />
          <div class="font">巨量引擎平台整合了今日头条、抖音、西瓜视频等产品的官方营销平台，用户群体庞大，积累了多维精准定向体系，实现精准投放，高效营销</div>
        </div>
        <div class="item-img">
          <img src="@/assets/images/solution/popularize-pic-01.png" alt="">
        </div>
      </div>
    </div>
    <div class="block-po02">
      <div class="content-03">
        <div class="item-img">
          <img src="@/assets/images/solution/popularize-pic-02.png" alt="">
        </div>
        <div class="item-lf">
          <div class="name">腾讯广告</div>
          <div class="line" />
          <div class="font">腾讯平台基于微信、QQ社交海量用户基础，拥有微信广告、微信附近推、qq广告，腾讯视频广告、腾讯新闻广告等，利用专业大数据算法，实现多种投放场景，满足不同投放需求</div>
        </div>
      </div>
    </div>
    <div class="block-po01">
      <div class="content-03">
        <div class="item-lf">
          <div class="name">快手广告</div>
          <div class="line" />
          <div class="font">国民级流量平台，真实性内容，生活化营销场景，垂直圈层渗透力高，拥有品牌广告、信息流广告、金牛电商等营销产品，满足多种应用场景与推广需求，智能精准匹配</div>
        </div>
        <div class="item-img">
          <img src="@/assets/images/solution/popularize-pic-03.png" alt="">
        </div>
      </div>
    </div>
    <div class="block-po02">
      <div class="content-03">
        <div class="item-img">
          <img src="@/assets/images/solution/popularize-pic-04.png" alt="">
        </div>
        <div class="item-lf">
          <div class="name">短视频营销</div>
          <div class="line" />
          <div class="font">自有3000平方制作和拍摄基地，高端拍摄器材、专业直播设备，资深视频拍摄团队，主播团队，根据客户行业匹配合适达人，专注短视频账号代运营、直播运营等定制化内容营销</div>
        </div>
      </div>
    </div>
    <div class="block-po01">
      <div class="sk-block-title">
        <div class="title">专业运营团队服务支持，提供方案</div>
      </div>
      <div class="content-04">
        <div class="item">
          <img src="@/assets/images/solution/popularize-icon2-01.png" alt="">
          <div class="name">免费营销策划服务</div>
        </div>
        <div class="item">
          <img src="@/assets/images/solution/popularize-icon2-03.png" alt="">
          <div class="name">素材加工、美化服务</div>
        </div>
        <div class="item">
          <img src="@/assets/images/solution/popularize-icon2-03.png" alt="">
          <div class="name">广告投放优化服务</div>
        </div>
      </div>
    </div>
    <div class="sk-flex8">
      <div class="sk-block-title">
        <div class="title">行业解决方案</div>
      </div>
      <div class="sk-flex8-icon-name">
        <div v-for="(item, index) in solutionList" :key="`solutionList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/popularize-icon3-0${index+1}.png`)" alt="">
          <div class="name">{{ item }}</div>
        </div>
      </div>
    </div>
    <CarouselItem title="流量推广" />
    <ConsultForm info-sources="流量推广" title="咨询服务 立即预约" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import CarouselItem from '@/components/CarouselItem'
export default {
  metaInfo: metaInfo.Popularize,
  name: 'Popularize',
  components: {
    ConsultForm,
    CarouselItem
  },
  data() {
    return {
      painSpotList: [
        {
          title: '单量少',
          subTitle: '销售业绩上不去<br/>广告、促销做了不少，但效果平平'
        },
        {
          title: '客流量少',
          subTitle: '开拓新客拿不准<br/>开拓新客无从下手，找不到精准客群'
        },
        {
          title: '知名度低',
          subTitle: '品牌名称打不响<br/>行业龙头垄断，没机会展示优势'
        }
      ],
      solutionList: ['家用电器', '农资行业', '交通出行', '酒水饮料', '家居建材', '数码3C', '餐饮行业', '快消行业']
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  padding: 70px 0 68px;
  background: url('~@/assets/images/solution/popularize_banner.png') no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    .banner-title {
      width: 320px;
      height: 90px;
      font-size: 32px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 45px;
      margin: 0 auto;
    }
    .popularize {
      display: flex;
      justify-content: space-between;
      width: 894px;
      margin: 37px auto 0;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 78px;
          height: 78px;
        }
        span {
          padding-top: 20px;
          font-size: 20px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 28px;
        }
      }
    }
    .desc {
      margin-top: 27px;
      font-size: 16px;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 22px;
    }
  }
}
.block-po01 {
  background: #fff;
}
.block-po02 {
  background: #F9F9F9;
}
.content-01 {
  display: flex;
  justify-content: space-around;
  width: 1200px;
  margin: 0 auto;
  padding: 53px 0 21px;
  .item {
    width: 262px;
    text-align: center;
    .title {
      color: #595961;
      font-size: 20px;
      font-weight: 500;
      margin: 14px 0 12px;
    }
    .sub-title {
      color: #8B8FA1;
      font-size: 16px;
    }
  }
}
.content-02 {
  width: 1200px;
  background: #fff;
  margin: 47px auto 0;
  padding-bottom: 48px;
  padding-top: 32px;
  display: flex;
  justify-content: space-around;
  .item{
    width: 298px;
    border-right: 1px solid #E8E8E8;
    &:nth-child(odd) {
      width: 300px;
    }
    &:last-child {
      border-right: none;
    }
    .line {
      width: 32px;
      height: 3px;
      background: #3986FF;
      margin: 0 auto 20px;
    }
    .name {
      font-size: 20px;
      color: #595961;
      font-weight: 500;
    }
    &:nth-child(1) .line{
      background: #87D5AF;
    }
    &:nth-child(3) .line {
      background: #EFBA67;
    }
  }
  .item-01 {
    .line {
      margin: -38px auto 20px;
    }
    .name {
      margin-top: -6px;
    }
  }
  .item-02 {
    .img {
      margin-top: 28px;
      margin-bottom: 57px;
    }
  }
  .item-03 {
    .img {
      margin-top: -46px;
      margin-bottom: 7px;
    }
  }
  .item-04 {
    .img {
      margin: 49px 0 48px;
    }
  }
}
.content-03 {
  width: 1200px;
  margin: 0 auto;
  padding: 49px 40px 76px;
  display: flex;
  justify-content: space-between;
  .item-lf {
    width: 420px;
    text-align: left;
  }
  .line {
    width: 20px;
    height: 3px;
    background: #01A1F5;
    margin: 8px 0 24px;
  }
  .name {
    color: #595961;
    font-size: 36px;
    font-weight: 500;
    margin-top: 82px;
  }
  .font {
    font-size: 20px;
    color: #8B8FA1;
    font-weight: 400;
  }
}
.content-04 {
  display: flex;
  justify-content: space-around;
  width: 1200px;
  margin: 0 auto;
  padding: 54px 0 112px;
  .item {
    width: 192px;
    text-align: center;
    color: #595961;
    font-size: 24px;
    &:nth-child(2) {
      width: 216px;
    }
    .name {
      margin-top: 30px;
    }
  }
}
</style>
